import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-stepper',
  templateUrl: './shared-stepper.component.html',
  styleUrls: ['./shared-stepper.component.scss'],
})
export class SharedStepperComponent {
  @Input() steps: SharedStepperStep[] = [];

  getCurrentClass(step: SharedStepperStep): { [key: string]: boolean } {
    return {
      'hmn-opacity__full': step.is_current,
      'hmn-opacity__one-quarter': !step.is_current,
    };
  }
}

export interface SharedStepperStep {
  label: string;
  is_current: boolean;
  translation: string;
}
